import { CreditCard, Loader2, Plus, Wallet } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { useLanguage } from "../i18n";

/** Selettore metodo di pagamento pre-acquisto: credito plafond / carta salvata / nuova carta.
 * Il genitore passa saldo e carta (GET /payments/saved-card) e riceve la scelta via onPick. */
export default function PaymentMethodDialog({ open, onOpenChange, title, priceLabel, walletBalance, card, busy, onPick }) {
  const { t } = useLanguage();
  const hasWallet = (walletBalance || 0) > 0;
  const hasCard = !!card?.saved;
  const opt = "w-full flex items-center gap-3 rounded-2xl border px-5 py-4 min-h-[44px] font-mono-t text-[11px] font-bold uppercase tracking-[0.12em] transition-colors disabled:opacity-60 text-left";
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!busy) onOpenChange(v); }}>
      <DialogContent data-testid="pay-method-dialog" aria-describedby="pay-method-desc" className="rounded-3xl sm:max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-slate-900">{t("pay.title")}</DialogTitle>
          <DialogDescription id="pay-method-desc" className="text-sm text-slate-500">
            {title} · <span className="font-mono-t font-bold text-[#FF6B35]">{priceLabel}</span>
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2.5 pt-1">
          {hasWallet && (
            <button type="button" data-testid="pay-method-wallet" onClick={() => onPick("wallet")} disabled={!!busy}
              className={`${opt} border-[#0D9488]/40 text-[#0D9488] hover:bg-[#0D9488]/5`}>
              {busy === "wallet" ? <Loader2 className="w-4 h-4 animate-spin shrink-0" /> : <Wallet className="w-4 h-4 shrink-0" />}
              <span>{t("pay.wallet")}</span>
              <span data-testid="pay-method-wallet-balance" className="ml-auto normal-case tracking-normal">€ {Number(walletBalance).toFixed(2)}</span>
            </button>
          )}
          {hasCard && (
            <button type="button" data-testid="pay-method-card" onClick={() => onPick("card")} disabled={!!busy}
              className={`${opt} border-slate-200 text-slate-800 hover:border-[#FF6B35]/60 hover:bg-orange-50/40`}>
              {busy === "card" ? <Loader2 className="w-4 h-4 animate-spin shrink-0" /> : <CreditCard className="w-4 h-4 shrink-0" />}
              <span className="capitalize">{card.brand || t("pay.card")}</span>
              <span className="ml-auto">•••• {card.last4}</span>
            </button>
          )}
          <button type="button" data-testid="pay-method-new-card" onClick={() => onPick("new_card")} disabled={!!busy}
            className={`${opt} border-slate-200 text-slate-800 hover:border-[#FF6B35]/60 hover:bg-orange-50/40`}>
            {busy === "new_card" ? <Loader2 className="w-4 h-4 animate-spin shrink-0" /> : <Plus className="w-4 h-4 shrink-0" />}
            <span>{t("pay.newCard")}</span>
            <span className="ml-auto">Stripe</span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
